import { SBLogo } from '@components';
import PropTypes from 'prop-types';

const ErrorPage = ({ errorCode, title, subTitle, children = null }) => (
  <div className="flex flex-col items-center justify-center h-screen text-center text-white bg-gradient-to-r from-blue-800 to-indigo-900 gap-y-3">
    <SBLogo className="w-auto h-40 mb-3" />
    <h1 className="font-bold text-8xl opacity-70">{errorCode}</h1>
    <h2 className="text-4xl font-semibold opacity-70">{title}</h2>
    <p className="max-w-lg mx-auto text-xl">{subTitle}</p>
    {children && children}
  </div>
)

ErrorPage.propTypes = {
  children: PropTypes.node,
  errorCode: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
}

export default ErrorPage